import React, { useState } from 'react';

interface ImageWithFallbackProps {
  src: string;
  alt: string;
  className?: string;
  loading?: 'lazy' | 'eager';
}

const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({ 
  src, 
  alt, 
  className = '', 
  loading = 'lazy' 
}) => {
  const [error, setError] = useState(false);
  const isHEIC = src.toLowerCase().endsWith('.heic');

  if (error || isHEIC) {
    return (
      <div className={`${className} bg-luxury-gray-light flex items-center justify-center`}>
        <div className="text-center p-8">
          <p className="text-luxury-gray text-sm font-body">
            {isHEIC ? 'HEIC format preview not available' : 'Image not available'}
          </p>
          <p className="text-luxury-gray-dark text-xs mt-2 font-body">
            {alt}
          </p>
        </div>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading={loading}
      onError={() => setError(true)}
    />
  );
};

export default ImageWithFallback;